import {forceLogout, getAccessToken} from "./authority";
import {toast} from "react-toastify";

// Get language from localStorage, default to 'vi'
const getLang = () => localStorage.getItem('sas_school_language') || 'vi';
let lang = getLang();


let token = getAccessToken();

// Hết phiên (HTTP 401 — contract ba-shared/api-contracts/auth/session-expiry.md):
// báo user lý do rồi mới về trang đăng nhập (chuyển trang ngay sẽ huỷ toast).
// Trả về true nếu là 401 để caller set isExpired và dừng xử lý.
// Chống trùng 2 lớp: cờ này + cờ isLoggingOut trong forceLogout.
let sessionExpiredNotified = false;
const handleUnauthorized = (response) => {
    if (response?.status !== 401) return false;
    if (!sessionExpiredNotified) {
        sessionExpiredNotified = true;
        toast.warning("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        setTimeout(forceLogout, 1500);
    }
    return true;
};

/**
 * Lấy câu lỗi HIỂN THỊ ĐƯỢC từ `BaseResponse` của server.
 *
 * ⚠️ Bẫy: `BaseResponse.message` phía server là **List<String>**
 * (api-common `BaseResponse.java` + `GlobalExceptionHandle`), nên
 * `toast.error(res.message)` truyền vào react-toastify một MẢNG. react-toastify v9 lọc nội dung
 * bằng `canBeRendered()` — chỉ nhận string/number/ReactElement/function — và **bỏ qua toast
 * trong im lặng** khi nhận mảng ⇒ user bấm nút, thao tác fail mà KHÔNG thấy thông báo nào.
 * Vì vậy mọi chỗ báo lỗi phải đi qua hàm này thay vì `res.message` trần.
 *
 * Ngoài ra đổi vài mã kỹ thuật do handler chung trả về thành câu tiếng Việt:
 *  - 500 → message = ["ERROR"]      (GlobalExceptionHandle.handleExceptions)
 *  - 403 → message = ["FORBIDDEN"]  (handleAccessDeniedException)
 *
 * @param {Object} res      response gốc {success, message, errorCode...}
 * @param {String} fallback câu thay thế khi server không nói gì
 * @returns {String} luôn là chuỗi — an toàn để đưa vào toast / alert
 */
export const apiMessage = (res, fallback = "Có lỗi xảy ra, vui lòng thử lại!") => {
    const raw = res && res.message;
    const text = Array.isArray(raw)
        ? raw.filter(Boolean).map(String).join("\n")
        : (typeof raw === "string" ? raw : "");
    if (!text.trim()) return fallback;
    if (text === "ERROR") return "Hệ thống gặp lỗi khi xử lý yêu cầu, vui lòng thử lại hoặc báo quản trị.";
    if (text === "FORBIDDEN") return "Bạn không có quyền thực hiện thao tác này.";
    return text;
};

export const request = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    if (token === undefined)
        token = getAccessToken();
    const abortController = request.timeoutMs ? new AbortController() : null;
    const timeoutId = abortController
        ? setTimeout(() => abortController.abort(), request.timeoutMs)
        : null;
    let config = {
        method: request.method,
        headers: token ?  {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        } : {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        },
        body: JSON.stringify(request.body),
        signal: abortController ? abortController.signal : undefined
        // body: request.body
    }
    let isExpired = false;
    return fetch(request?.url,config)
        .then(async response => {
            if (handleUnauthorized(response)) {
                isExpired = true;
                return null;
            }
            // else if (response?.status == 500) {
            //     return {"success":true,"data": null,"errorCode":null,"message":null,"refCode":null}
            // }
            // console.log("check response fetch>>>>", response)
            return response.json()
        })
        .then((res) => {
            if (!isExpired) callback(res);
        })
        .catch((error) => {
            console.error('API Error:', error);
            if (isExpired) return;
            if (error?.name === 'AbortError') {
                if (callback) {
                    callback({
                        success: false,
                        errorCode: 'REQUEST_TIMEOUT',
                        message: 'Yêu cầu quá thời gian chờ, vui lòng thử lại'
                    });
                }
                return;
            }
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        })
        .finally(() => {
            if (timeoutId) clearTimeout(timeoutId);
        })
};

export const requestLogin = (request, callback) =>{
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        },
        body: JSON.stringify(request.body)
        // body: request.body
    }
    return fetch(request?.url,config)
        .then(async response => {
            if (response?.status === 401) {
                toast.error("Sai tên đăng nhập hoặc mật khẩu!")
            }
            return response.json()
        })
        .then((res) => {
            callback(res);
        })
        .catch((error) => {
            console.log(error)
            toast.error("Sai tên đăng nhập hoặc mật khẩu!")
            // callback(error.json())
        })
};

export const requestUploadPublic = (request, callback) =>{
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    let isExpired = false;
    return fetch(request?.url,config)
        .then(async response => {
            if (handleUnauthorized(response)) {
                isExpired = true;
                return null;
            }
            return response.json()
        })
        .then((res) => {
            if (!isExpired) callback(res);
        })
        .catch((error) => {
            if (isExpired) return;
            console.error('Upload Public Error:', error);
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        });
};

export const requestUpload = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            "Accept-Language": lang
        },
        body: request.body,
    }
    let isExpired = false;
    return fetch(request?.url,config)
        .then(async response => {
            if (handleUnauthorized(response)) {
                isExpired = true;
                return null;
            }
            return response.json()
        })
        .then((res) => {
            if (!isExpired) callback(res);
        })
        .catch((error) => {
            if (isExpired) return;
            console.error('Upload Error:', error);
            if (callback) {
                callback({ success: false, errorCode: 'NETWORK_ERROR', message: error?.message || 'Lỗi kết nối mạng' });
            }
        });
};

/**
 * Câu lỗi đọc được cho người dùng từ `BaseResponse` lỗi của server.
 *
 * Server trả `message` dạng **mảng mã lỗi** (`["FORBIDDEN"]`) chứ không phải câu tiếng Việt, nên
 * dịch các mã hay gặp; mã lạ thì trả nguyên văn còn hơn nuốt mất.
 */
const downloadErrorMessage = (body, status) => {
    const raw = Array.isArray(body?.message) ? body.message.join(', ') : body?.message;
    const code = body?.errorCode || raw;
    if (code === 'FORBIDDEN' || status === 403) {
        return "Bạn không có quyền tải file này. Đề nghị quản trị cấp quyền 'Tải' (DOWNLOAD) của chức năng tương ứng.";
    }
    if (status === 404) {
        return "Không tìm thấy dữ liệu để xuất file, vui lòng kiểm tra lại!";
    }
    return raw || "Download không thành công, vui lòng thử lại!";
};

/**
 * Tải file nhị phân từ một endpoint GET/POST.
 *
 * ⚠️ Endpoint export trả **file khi thành công** nhưng **JSON `BaseResponse` khi lỗi**
 * (403 thiếu quyền, 400 sai tham số, 404 không có dữ liệu). Vì vậy phải xem `response.ok` và
 * `Content-Type` TRƯỚC khi gọi `blob()` — bản cũ lưu thẳng mọi status ngoài 400/404/500 thành
 * file, nên 403 rơi vào ổ cứng dưới dạng .xlsx 92 byte chứa `{"errorCode":"FORBIDDEN"}` và Excel
 * báo file hỏng. Người dùng mất cả buổi tưởng lỗi máy chủ, trong khi chỉ thiếu một ô tích quyền.
 *
 * Tên file lấy theo thứ tự: header `Content-Disposition` → `request.fileName`.
 *
 * @param {Object} request - { url, method, body, fileName }
 * @param {Function} callback - nhận { success, message }
 */
export const requestDownload = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            // "Content-Type": "multipart/form-data",
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    let isExpired = false;
    return fetch(request?.url,config)
        .then(async response => {
            if (handleUnauthorized(response)) {
                isExpired = true;
                return null;
            }
            if (!response.ok) {
                const body = await response.json().catch(() => null);
                throw new Error(downloadErrorMessage(body, response.status));
            }
            // Gateway/Spring có lúc trả 200 kèm JSON lỗi — vẫn không được lưu thành file.
            const contentType = response.headers.get('Content-Type') || '';
            if (contentType.includes('json')) {
                const body = await response.json().catch(() => null);
                throw new Error(downloadErrorMessage(body, response.status));
            }
            const disposition = response.headers.get('Content-Disposition') || '';
            const matched = /filename[^;=\n]*=(?:UTF-8'')?"?([^";\n]*)"?/i.exec(disposition);
            const fileName = matched ? decodeURIComponent(matched[1].trim()) : request.fileName;
            return { blob: await response.blob(), fileName };
        })
        .then((res) => {
            if (isExpired || !res) return;
            const fileURL = URL.createObjectURL(res.blob);
            let a = document.createElement('a');
            a.href = fileURL;
            a.download = res.fileName || request.fileName || 'download';
            a.click();
            // Revoke objectURL to prevent memory leak
            setTimeout(() => URL.revokeObjectURL(fileURL), 100);
            if (callback) callback({ success: true });
        })
        .catch(error => {
            if (isExpired) return;
            console.error('Download Error:', error);
            const message = error?.message || "Download không thành công, vui lòng thử lại!";
            toast.error(message);
            // Phải gọi callback cả khi lỗi, nếu không nút gọi hàm này kẹt mãi ở "Đang xuất...".
            if (callback) callback({ success: false, message });
        })
};

/**
 * Tải file từ endpoint nhận **JSON body** (`@RequestBody`), khác `requestDownload` ở hai chỗ
 * bắt buộc: có `Content-Type: application/json` và `JSON.stringify(body)`.
 * Thiếu một trong hai thì Spring trả 415/400 vì `fetch` gửi object thành chuỗi "[object Object]".
 *
 * Tên file lấy theo thứ tự: header `Content-Disposition` của server → `request.fileName`.
 * Server đặt tên có timestamp nên ưu tiên header để 2 lần tải không đè lên nhau.
 *
 * ⚠️ Endpoint export trả **file nhị phân khi thành công** nhưng vẫn trả **JSON `BaseResponse`
 * khi lỗi** (400 thiếu tham số, 403 thiếu quyền). Vì vậy phải xem status TRƯỚC khi gọi `blob()`,
 * nếu không sẽ lưu ra file .xlsx chứa JSON và Excel báo hỏng file.
 *
 * @param {Object} request - { url, method='POST', body, fileName }
 * @param {Function} callback - nhận { success, message }
 */
export const requestDownloadJson = (request, callback) => {
    token = getAccessToken();
    lang = getLang();
    const config = {
        method: request.method || 'POST',
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json; charset=UTF-8",
            "Accept-Language": lang
        },
        body: JSON.stringify(request.body)
    };
    return fetch(request?.url, config)
        .then(async response => {
            if (handleUnauthorized(response)) return null;
            if (!response.ok) {
                // Lỗi luôn là JSON — đọc lấy đúng câu server nói thay vì báo chung chung
                const err = await response.json().catch(() => null);
                const message = Array.isArray(err?.message) ? err.message.join(', ') : err?.message;
                throw new Error(message || "Xuất file không thành công, vui lòng thử lại!");
            }
            const disposition = response.headers.get('Content-Disposition') || '';
            const matched = /filename[^;=\n]*=(?:UTF-8'')?"?([^";\n]*)"?/i.exec(disposition);
            const fileName = matched ? decodeURIComponent(matched[1].trim()) : request.fileName;
            return {blob: await response.blob(), fileName};
        })
        .then((res) => {
            if (!res) return;
            const fileURL = URL.createObjectURL(res.blob);
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = res.fileName || 'download.xlsx';
            a.click();
            setTimeout(() => URL.revokeObjectURL(fileURL), 100);
            if (callback) callback({success: true});
        })
        .catch(error => {
            console.error('Download Error:', error);
            const message = error?.message || "Xuất file không thành công, vui lòng thử lại!";
            toast.error(message);
            if (callback) callback({success: false, message});
        });
};

export const requestShow = (request, callback) =>{
    token = getAccessToken();
    lang = getLang(); // Update language on each request
    let config = {
        method: request.method,
        headers: {
            "Authorization": "Bearer " + token,
            // "Content-Type": "multipart/form-data",
            "Accept-Language": lang
        },
        // body: JSON.stringify(request.body)
        body: request.body
    }
    let isExpired = false;
    return fetch(request?.url,config)
        .then(async response => {
            if (handleUnauthorized(response)) {
                isExpired = true;
                return null;
            }
            else if (response?.status === 500) {
                return response.json()
            }
            else if (response?.status === 400) {
                return response.json()
            }
            else if (response?.status === 404) {
                toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!")
                return response.json()
            }
            else return response.blob()
        })
        .then((res) => {
            if (isExpired) return;
            // if (!res.success) {
            //     return toast.error("Download không thành công, vui lòng thử lại!")
            // }  else {
            if (res) {
                const fileURL = URL.createObjectURL(res);
                callback(fileURL);
            }
            // }
            // const fileURL = URL.createObjectURL(res);
            // // window.open(fileURL)
            // saveAs(fileURL);
            // callback(fileURL);
        })
        .catch(error => {
            if (isExpired) return;
            console.error('Show Error:', error);
            if (error?.status === 404) {
                return toast.error("File không tồn tại hoặc đã bị mất, vui lòng thử lại!");
            }
            return toast.error("Download không thành công, vui lòng thử lại!");
        })
};
